import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "html-events-and-event-listeners"
    }}>{`HTML events and event listeners`}</h1>
    <p>{`There are different techniques to capture an HTML event and add `}<inlineCode parentName="p">{`eventlisteners`}</inlineCode>{` to an element.`}</p>
    <p>{`The technique you choose is simply your preference. Pick the method you feel most comfortable with. However, you need to configure one particular permission for inline event handlers, such as `}<inlineCode parentName="p">{`<button onclick="btnClick()">Click Me</button>`}</inlineCode>{` `}</p>
    <InlineAlert variant="info" slots="header, text1, text2" mdxType="InlineAlert" />
    <p>{`Plugins and Scripts`}</p>
    <p><strong parentName="p">{`In plugins`}</strong>{`, you will need to enable `}<inlineCode parentName="p">{`allowCodeGenerationFromStrings`}</inlineCode>{` if you would like to use the inline event handlers shown above. `}<br></br>{`
IMPORTANT: Please read about the `}<a parentName="p" {...{
        "href": "../../../plugins/concepts/manifest/#permissionsdefinition"
      }}>{`manifest permissions`}</a>{` module before you proceed.`}</p>
    <p><strong parentName="p">{`In scripts`}</strong>{`, since you cannot add inline event listeners, this permission is not applicable.`}</p>
    <h2 {...{
      "id": "system-requirements"
    }}>{`System requirements`}</h2>
    <p>{`Please make sure your local environment uses the following application versions before proceeding.`}</p>
    <ul>
      <li parentName="ul">{`InDesign v18.5 or higher`}</li>
      <li parentName="ul">{`UDT v1.9.0 or higher`}</li>
      <li parentName="ul">{`Manifest version v5 or higher`}</li>
    </ul>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p><strong parentName="p">{`Declaring event listeners in JavaScript`}</strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="HTML, JavaScript" mdxType="CodeBlock" />
    <h4 {...{
      "id": "html"
    }}>{`HTML`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<button id="firstButton">Click me</button>
<button id="secondButton">Click me</button>
`}</code></pre>
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const firstButton = document.getElementById("firstButton");
firstButton.addEventListener("click", foo);

const secondButton = document.getElementById("secondButton");
secondButton.onclick = foo;

function foo(event) {
    console.log(\`Button clicked \${event.target.id}\`);
}
`}</code></pre>
    <p><strong parentName="p">{`Declaring inline event handlers`}</strong></p>
    <CodeBlock slots="heading, code" repeat="3" languages="HTML, JavaScript, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "html-1"
    }}>{`HTML`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<button id="thirdButton" onclick='foo(event)'>Click me</button>
`}</code></pre>
    <h4 {...{
      "id": "javascript-1"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function foo(event) {
    console.log(\`Button clicked \${event.target.id}\`);
}
`}</code></pre>
    <h4 {...{
      "id": "manifest"
    }}>{`manifest`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "requiredPermissions": {
        "allowCodeGenerationFromStrings" : true
    }
}
`}</code></pre>
    <h2 {...{
      "id": "additional-notes"
    }}>{`Additional notes`}</h2>
    <ul>
      <li parentName="ul">{`The above examples will also work for Spectrum Widgets and Spectrum Web Components in UXP.`}</li>
    </ul>
    <h2 {...{
      "id": "reference-material"
    }}>{`Reference material`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Events/"
        }}>{`HTML Events`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      